import { createElement } from 'react';
import { string, number } from 'prop-types';
import 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
import { c as _extends } from '../chunk-ad6ad343.js';
import Box from 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import _Spinner, { Circle } from './styled.js';

var Spinner = function Spinner(_ref) {
  var props = _extends({}, _ref);

  return createElement(Box, _extends({}, props, {
    size: undefined
  }), createElement(_Spinner, {
    viewBox: "22 22 44 44",
    styledSize: props.size,
    value: props.value
  }, createElement(Circle, {
    cx: "44",
    cy: "44",
    r: "20",
    fill: "none",
    strokeWidth: "4",
    color: props.color,
    value: props.value
  })));
};

var spinnerPropTypes = {
  className: string,
  color: string,
  size: string,
  value: number
};
Spinner.propTypes = spinnerPropTypes;
var spinnerDefaultProps = {
  className: undefined,
  color: 'primary',
  size: 'default',
  value: undefined
};
Spinner.defaultProps = spinnerDefaultProps; // @ts-ignore

var C = Spinner;
export default C;
export { C as Spinner, spinnerDefaultProps, spinnerPropTypes };